"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _blocks = require("@bueno/blocks");

var _Menu = _interopRequireDefault(require("../../components/Menu"));

var _segment = _interopRequireDefault(require("../../utils/segment"));

var _Menu2 = require("../../components/Menu/Menu.styles");

var _ToggleSnoozed = require("./ToggleSnoozed.styles");

var _actionCreators = require("../../redux/modules/insights/actionCreators");

function toggleShowSnoozeTracked(cb, showSnoozed) {
  return () => {
    _segment.default.track(`Snooze switched ${showSnoozed ? 'off' : 'on'}`);

    cb();
  };
}

function toggleMenuTracked(isOpen) {
  _segment.default.track(`Snooze popover ${isOpen ? 'opened' : 'closed'}`);
}

function mapStateToProps(state) {
  return {
    showSnoozed: state.insights.showSnoozed
  };
}

function mapDispatchToProps(dispatch) {
  return {
    toggleSnoozed: () => dispatch((0, _actionCreators.toggleShowSnoozed)())
  };
}

const ToggleSnoozed = ({
  className,
  toggleSnoozed,
  showSnoozed,
  count
}) => /*#__PURE__*/_react.default.createElement(_Menu.default, {
  onToggle: toggleMenuTracked
}, ({
  isOpen,
  menuRef,
  toggle
}) => /*#__PURE__*/_react.default.createElement(_ToggleSnoozed.$Wrapper, {
  className: className,
  ref: menuRef,
  "data-cy": "ToggleSnoozed"
}, /*#__PURE__*/_react.default.createElement(_ToggleSnoozed.$Label, {
  onClick: toggle,
  "data-cy": "ToggleSnoozed-button"
}, /*#__PURE__*/_react.default.createElement(_ToggleSnoozed.$IconBubble, {
  count: count
}, count), /*#__PURE__*/_react.default.createElement(_blocks.SnoozeBadgeOutline, {
  fillColor: _blocks.palette.neutral9
})), /*#__PURE__*/_react.default.createElement(_ToggleSnoozed.$List, {
  isOpen: isOpen
}, /*#__PURE__*/_react.default.createElement(_Menu2.$MenuTitle, null, "SNOOZED ITEMS (", count, ")"), /*#__PURE__*/_react.default.createElement(_ToggleSnoozed.$Setting, {
  type: "button"
}, /*#__PURE__*/_react.default.createElement(_blocks.Checkbox, {
  checked: showSnoozed,
  label: "Show snoozed",
  onChange: toggleShowSnoozeTracked(toggleSnoozed, showSnoozed)
})))));

ToggleSnoozed.propTypes = {
  className: _propTypes.default.string,
  toggleSnoozed: _propTypes.default.func,
  showSnoozed: _propTypes.default.bool,
  count: _propTypes.default.number
};
ToggleSnoozed.defaultProps = {
  className: '',
  count: 0
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ToggleSnoozed);

exports.default = _default;
module.exports = exports.default;